module.exports = __webpack_public_path__ + "static/media/training-redesigned.785c630a.png";